export function set_theme() {
  const theme = this.getAttribute('theme')

  if (theme === 'dark') {
    document.documentElement.classList.remove('light', 'system')
  } else if (theme === 'light') {
    document.documentElement.classList.remove('dark', 'system')
  } else {
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches

    if (prefersDark) {
      document.documentElement.classList.remove('light')
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  document.documentElement.classList.add(theme)
}
